module.exports = __webpack_public_path__ + "static/media/gas.94b54cef.png";